/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { IViewerSourceCreator } from '../../video'
 * @import HtmlVideoRepairer from '../../html/html-video-repairer'
 * @import PoolFactory from '../../pool/pool-factory'
 * @import { ViewerSourceFactory } from '../source'
 */

// TODO Unit testy.
/**
 * Poskytovatel zdrojů pro zobrazování HTML video elementů.
 * Implementuje návrhový vzor Object pool pro tvorbu zdrojů.
 * Provádí recyklaci vrácených zdrojů pro další použití.
 * @implements {IViewerSourceCreator}
 */
export default class ViewerSourceVideoCreator {
  /**
   * Vytvoří instanci.
   * @param {PoolFactory} poolFactory
   * @param {HtmlVideoRepairer} repairer
   * @param {ViewerSourceFactory} sourceFactory Továrna na zdroje, které se poskytují.
   */
  constructor(poolFactory, repairer, sourceFactory) {
    this.pool = poolFactory.create(sourceFactory);
    this.repairer = repairer;
    this.sourceFactory = sourceFactory;
  }

  /** @type {IViewerSourceCreator['delete']} */
  delete(source) {
    // Při odebírání velkého počtu video elementů z DOM dochází ve většině prohlížečů k paměťovým únikům.
    // Proto se místo odebrání provede pokus o vyčištění zdroje a jeho následné vrácení do pool pro další použití.
    return new Promise((resolve) => {
      source.getFrame().repair();
      return resolve(
        this.repairer
          .repair(source.getEl())
          .then(() => this.pool.receive(source))
      );
    });
  }

  /** @type {IViewerSourceCreator['destroy']} */
  destroy() {
    this.pool.destroy();
  }

  /** @type {IViewerSourceCreator['getLent']} */
  getLent() {
    return this.pool.getLent();
  }

  /** @type {IViewerSourceCreator['getMax']} */
  getMax() {
    return this.pool.getMax();
  }

  /** @type {IViewerSourceCreator['isUsingVideoElement']} */
  isUsingVideoElement() {
    return true;
  }

  /** @type {IViewerSourceCreator['lend']} */
  lend(parentEl) {
    return new Promise((resolve) => {
      // Nastaví se rodičovský element továrny, aby do něj vytvářela nové zdroje.
      // Nastavuje se dopředu, aby byl rodičovský element dostupný v okamžiku plnění bazénu.
      this.sourceFactory.setParentEl(parentEl);
      // Vypůjčení zdroje z bazénu.
      const source = this.pool.lend();
      // Nastaví se rodičovský element továrny, aby do něj vytvářela nové zdroje.
      // Nastavuje se duplicitně, protože není jistota, že datový zdroj vytvoří továrna.
      // Může dojít k recyklaci a zdroj může mít nastaven starý rodičovský element.
      source.setParentEl(parentEl);
      return resolve(source);
    });
  }

  /** @type {IViewerSourceCreator['receive']} */
  receive(source) {
    return new Promise((resolve) =>
      resolve(
        this.repairer
          .repair(source.getEl())
          .then(() => this.pool.receive(source))
      )
    );
  }

  /** @type {IViewerSourceCreator['replace']} */
  replace() {
    // Není třeba nic provést.
    return Promise.resolve();
  }
}
